module.exports = __webpack_public_path__ + "static/media/how-jama-wealth-img.fda40706.svg";